import { AccessorsMutatorsDecorator, Model } from "../../helpers";

/**
 * @class PropertyAmenity
 * @property {number} id
 * @property {Property} property
 * @property {DefaultPropertyAmenity} name
 */
export class PropertyAmenity extends Model {
    
}

AccessorsMutatorsDecorator('id', 'property_id', 'default_property_amenity_id')(PropertyAmenity);


// WEBPACK FOOTER //
// ./src/pms-api/models/property-amenity.model.js